import { type Locale } from "date-fns";

import { LocalizedTime, localizeTime } from "./LocalizedTime";

interface Props {
  fromDate: Date;
  toDate: Date;
  timezone?: string;
}

export const LocalizedTimeRange = ({ fromDate, toDate, timezone }: Props) => {
  return (
    <>
      <LocalizedTime date={fromDate} timezone={timezone} /> -{" "}
      <LocalizedTime date={toDate} timezone={timezone} />
    </>
  );
};

export const localizeTimeRange = (
  from: Date | string,
  to?: Date | string,
  dateFnsLocale?: Locale,
  timezone?: string
) => {
  return `${localizeTime(from, dateFnsLocale, timezone)}${
    to ? ` - ${localizeTime(to, dateFnsLocale, timezone)}` : ""
  }`;
};
